import { api } from '@/scripts/api';

export const LandingPageTemplateService = {

    get(id, config = {}) {
        return new Promise((resolve, reject) => {

            const service = '/service/LandingPageTemplates';

            const endpoint = api.applyODataParams(service, {
                ...config,
                filter: `Id eq ${ id }`,
            });

            api
                .get(endpoint)
                .then(resolve)
                .catch(reject);
        });
    },

    getAll(config = {}, signal) {
        return new Promise((resolve, reject) => {

            const service = '/service/LandingPageTemplates';

            const endpoint = api.applyODataParams(service, config);

            api
                .get(endpoint, signal)
                .then(resolve)
                .catch((error)=>{
                    if (!api.isCanceled(error)) {
                        reject(error);
                }});
        });
    },

    post(payload) {
        return new Promise((resolve, reject) => {
            api
                .post('/api/LandingPageTemplates', payload)
                .then(resolve)
                .catch(reject);
        });
    },

    patch(id, payload) {
        return new Promise((resolve, reject) => {
            const service = `/api/LandingPageTemplates/${ id }`;

            api.patch(service, payload)
                .then(resolve)
                .catch(reject);
        });
    },

    delete(id) {
        return new Promise((resolve, reject) => {
            const service = `/api/LandingPageTemplates/${ id }`;

            api
                .delete(service)
                .then(resolve)
                .catch(reject);
        });
    },

    duplicate(id, payload) {
        return new Promise((resolve, reject) => {
            const service = `/api/LandingPageTemplates/${ id }/Duplicate`;

            api
                .post(service, payload)
                .then(resolve)
                .catch(reject);
        });
    },

    publish(id, clientIds) {

        return new Promise((resolve, reject) => {

            const service = `/api/LandingPageTemplates/${ id }/Publish`;

            api
                .post(service, clientIds)
                .then(resolve)
                .catch(reject);
        });

    },

    unpublish(id) {
        return new Promise((resolve, reject) => {
            const service = `/api/LandingPageTemplates/${ id }/Publish`;

            api
                .post(service, [])
                .then(resolve)
                .catch(reject);
        });
    },

    getSharedAssets(id, config = {}) {
        return new Promise((resolve, reject) => {
            const service = '/service/SharedAssets';

            const endpoint = api.applyODataParams(service, {
                ...config,
                filter: `LandingPageTemplateId eq ${ id }`,
            });

            api
                .get(endpoint)
                .then(resolve)
                .catch(reject);
        })
    },

    getClient(id, config = {}) {
        return new Promise((resolve, reject) => {
            const service = '/service/Clients';

            const endpoint = api.applyODataParams(service, {
                ...config,
                filter: `Id eq ${ id }`,
            });

            api
                .get(endpoint)
                .then(resolve)
                .catch(reject);
        })
    },

    getClients(config = {}) {
        return new Promise((resolve, reject) => {
            const service = '/service/Clients';

            const endpoint = api.applyODataParams(service, config);

            api
                .get(endpoint)
                .then(resolve)
                .catch(reject);
        })
    },

    addToMyLandingPageTemplates(accountId, id) {
        return new Promise((resolve, reject) => {
            const service = `/api/Accounts/${accountId}/LandingPageTemplates/${id}/Add`;

            api
                .post(service)
                .then(resolve)
                .catch(reject)
        })
    }
}